import React from 'react';
import {useTranslation} from 'react-i18next';

const NoData = ({message = 'nodata', containerClass}) => {
    const {t} = useTranslation();

  return (
    <div className={`xpress_no_trans text-center ${containerClass}`}>
      <img
        src={process.env.PUBLIC_URL + '/assets/images/Generic_empty_icon.svg'}
        alt=""
        title=""
      />
      <div className="mb-5">
        <label>{t(message)}</label>
      </div>
    </div>
  );
};

export default NoData;
